import { render, staticRenderFns } from "./feedbackModal.vue?vue&type=template&id=0f290a3b&scoped=true&"
import script from "./feedbackModal.vue?vue&type=script&lang=js&"
export * from "./feedbackModal.vue?vue&type=script&lang=js&"
import style0 from "./feedbackModal.vue?vue&type=style&index=0&id=0f290a3b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f290a3b",
  null
  
)

export default component.exports